import React from 'react'
import { List, Header, } from 'semantic-ui-react'
import { FacebookShareButton, FacebookShareCount, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from "react-share"

const shareUrlWindowsv001 = 'https://rebrand.ly/dystater_v0-0-1-beta_windows';
const shareUrlWindowsv0100 = 'https://rebrand.ly/dystater_v0-1-00-beta_windows';
const shareUrlWindowsv020 = 'https://rebrand.ly/dystater_v0-2-0-4-beta_windows';
const shareUrlWindowsv030 = 'https://rebrand.ly/dystater_0-3-0_win64_setup';
const shareUrlUbuntuv001 = 'https://rebrand.ly/dystater_v0-0-1-beta_ubuntu';
const shareUrlUbuntuv0100 = 'https://rebrand.ly/dystater_v0-1-00-beta_ubuntu';
const shareUrlUbuntuv020 = 'https://rebrand.ly/dystater_v0-2-0-4-beta_ubuntu';
const shareUrlUbuntuv030 = 'https://rebrand.ly/dystater_0-3-0_linux64';


const title = 'Download Dystater';

const Dystater = () => (

    <List divided relaxed>
        <Header as="h3" textAlign="center">Please select the version you would like to download</Header>
        <List.Item>
            <List.Content>
                <br />


                <List.Header >Recent Mediafire links</List.Header>
                
                <br />

                <List.Header href="https://rebrand.ly/dystater_0-3-0_win32_setup" target="_blank" as='a'>Dystater version 0.3.0.0-beta, Windows 32 bit installer.</List.Header>
                <List.Header href="https://rebrand.ly/dystater_0-3-0_win64_setup" target="_blank" as='a'>Dystater version 0.3.0.0-beta, Windows 64 bit installer.</List.Header>
                <List.Header href="https://rebrand.ly/dystater_0-3-0_win32" target="_blank" as='a'>Dystater version 0.3.0.0-beta, Windows 32 bit installer archive.</List.Header>
                <List.Header href="https://rebrand.ly/dystater_0-3-0_win64" target="_blank" as='a'>Dystater version 0.3.0.0-beta, Windows 64 bit installer archive.</List.Header>
                <List.Description as='a'>(Latest)Uploaded on 7 June 2023</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlWindowsv030}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlWindowsv030}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlWindowsv030}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>
                <List.Header href="https://rebrand.ly/dystater_0-3-0_linux32" target="_blank" as='a'>Dystater version 0.3.0.0-beta, Ubuntu 32 bit package.</List.Header>
                <List.Header href="https://rebrand.ly/dystater_0-3-0_linux64" target="_blank" as='a'>Dystater version 0.3.0.0-beta, Ubuntu  64 bit package.</List.Header>
                <List.Description as='a'>(Latest)Uploaded on 7 June 2023</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlUbuntuv030}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlUbuntuv030}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlUbuntuv030}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>
                <br />

                <List.Header >Old Mediafire links</List.Header>
                <br />
                
                
                <br />

                <List.Header href="https://rebrand.ly/dystater_v0-2-0-4-beta_windows" target="_blank" as='a'>Dystater version 0.2.0.4-beta Windows installer</List.Header>
                <List.Description as='a'>(Latest)Uploaded on 24 April 2023</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlWindowsv020}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlWindowsv020}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlWindowsv020}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>
                <List.Header href="https://rebrand.ly/dystater_v0-2-0-4-beta_ubuntu" target="_blank" as='a'>Dystater version 0.2.0.4-beta Ubuntu package</List.Header>
                <List.Description as='a'>(Latest)Uploaded on 24 April 2023</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlUbuntuv020}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlUbuntuv020}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlUbuntuv020}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>
                <br />


                <List.Header href="https://rebrand.ly/dystater_v0-1-00-beta_windows" target="_blank" as='a'>Dystater version 0.1.00-beta Windows installer</List.Header>
                <List.Description as='a'>Uploaded on 13 April 2021</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlWindowsv0100}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlWindowsv0100}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlWindowsv0100}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>

                <List.Header href="https://rebrand.ly/dystater_v0-1-00-beta_ubuntu" target="_blank" as='a'>Dystater version 0.1.00-beta Ubuntu package</List.Header>
                <List.Description as='a'>Uploaded on 13 April 2021</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlUbuntuv0100}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlUbuntuv0100}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlUbuntuv0100}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>
                <br />


                



                {/* <List.Header href="https://rebrand.ly/dystater_v0-0-1-beta_windows" target="_blank" as='a'>Dystater version 0.0.1-beta Windows installer</List.Header>
                <List.Description as='a'>Uploaded on 31 January 2021</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlWindowsv001}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlWindowsv001}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlWindowsv001}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description>






                <List.Header href="https://rebrand.ly/dystater_v0-0-1-beta_ubuntu" target="_blank" as='a'>Dystater version 0.0.1-beta Ubuntu package</List.Header>
                <List.Description as='a'>Uploaded on 31 January 2021</List.Description>
                <List.Description as='a'>
                    <h4>Share the link: </h4>
                    <List divided relaxed horizontal>
                        <List.Item>

                            <FacebookShareButton
                                url={shareUrlUbuntuv001}
                                quote={title}
                                className="Demo__some-network__share-button">
                                <FacebookIcon
                                    size={32}
                                    round />
                            </FacebookShareButton>
                        </List.Item>

                        <List.Item>

                            <TwitterShareButton
                                url={shareUrlUbuntuv001}
                                title={title}
                                className="Demo__some-network__share-button">
                                <TwitterIcon
                                    size={32}
                                    round />
                            </TwitterShareButton>

                        </List.Item>

                        <List.Item>
                            <WhatsappShareButton
                                url={shareUrlUbuntuv001}
                                title={title}
                                separator=":: "
                                className="Demo__some-network__share-button">
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </List.Item>
                    </List>
                </List.Description> */}






            </List.Content>
        </List.Item>
    </List>
)

export default Dystater
